module.exports = __webpack_public_path__ + "img/menu_black.85e91dff.svg";